import styled from 'styled-components';
import { Card } from '@minerva-analytics/pantheon';
import media from '../../oldpantheon/utils/media';
import { BLACK } from '../../theme';

export const SignupFormContainer = styled(Card)`
  padding: 3rem 3rem 1rem 3rem;
  background-color: #ffffff;
  border: none;
  box-shadow: 2px 3px 7px rgba(0, 0, 0, .1);
  border-radius: 0.625rem;
  max-width: 40.625rem;
  width: 90%;
  position: relative;
  overflow: scroll;

  ${media.tablet`
    padding: 2rem 2rem 1rem 2rem
  `}
`;

export const SignupHeader = styled.h2`
  text-align: center;
  font-size: 2em;
  margin-bottom: 0.5rem;

  ${media.extraSmall`
    font-size: 1.5rem;
  `}
`;

export const LegalText = styled.p`
  margin-top: 1.25rem;
  text-align: center;
  color: ${BLACK};
  font-size: .75rem;

  Link {
    color: ${BLACK};
  }
`;

export const ModalLogo = styled.img`
  width: 12.5rem;
  margin: 0 auto 1.25rem auto;
  display: block;

  @media only screen and (max-width: 21.875rem) {
    display: none;
  }
`;

export const SignUpSubheader = styled.h3`
  font-weight: lighter;
  text-align: center;
  font-size: 1.375rem;
  margin: 0rem auto .5rem auto;
  color: ${BLACK};
  max-width: 31.25rem;

  ${media.extraSmall`
    font-size: 1rem;
  `}
`;

export const ModalCloseIcon = styled.button`
  position: absolute;
  top: 1rem;
  right: 0;
  border: none;
  background-color: none;
  padding: 0;
  width: 1.5rem;
  height: 1.5rem;
  outline: none !important;
  margin: 0 0.9rem;
  background-color: #ffffff;

  & svg {
    color: ${BLACK};
  }

  &:hover {
    color: ${BLACK};
    cursor: pointer;
  }

  &:active {
    border: none !important;
    outline: none !important;
  }
`;

export const ReturnToSiteText = styled.div`
  color: ${BLACK};
  text-align: center;
  margin-top: 1.25rem;
`;

export const ReturnToSiteLink = styled.div`
  cursor: pointer;
  color: ${BLACK};
  text-decoration: underline;
  font-weight: bold;
`;

export const SubheaderEmphasis = styled.span`
  font-weight: 700;
  font-family: "Calistoga";
`;
